<template>
  <div class="single-text-widget">
    <div class="dual-inputs">
      <div class="input">
        <AutoComplete
          :items="column.suffixes"
          filled
          dense
          class="input-md app-drop-down mb-3"
          active
          item-value="operand"
          item-text="operand"
          autocomplete="off"
          v-model="selected"
          :tabindex="2"
          @change="handleOnChangeOperand"
        />
      </div>
      <div class="input">
        <Input
          v-model="value"
          @keyup="handleOnValueChange"
          :placeholder="$t('enter_value')"
          class="input-md mb-5"
          autocomplete="off"
          outlined
          :tabindex="1"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { $eventHub } from "@/components";
import { EventConstraints } from "@/enums/events.enum";
import { WIDGETS_STATE } from "@/enums/filter.enum";
export default {
  name: "SingleTextWidget",

  data() {
    return {
      selected: "",
      value: "",
    };
  },

  props: {
    operands: {
      type: Array,
      default: () => [],
    },
    widget: {
      type: Object,
      default: () => {},
    },
    column: {
      type: Object,
      default: () => {},
    },
  },

  mounted() {
    console.log(this.column);
    this.value = this.column?.value || "";
    this.selected = this.widget.operand;
  },

  methods: {
    /**
     * will handle changing the operand
     * @return {void}
     */
    handleOnChangeOperand() {
      this.column.selectOperand(this.selected);
    },

    /**
     * will handle changing the value search
     * @return {void}
     */
    handleOnValueChange() {
      this.column.value = this.value;
      this.column.value
        ? (this.column.widgetState = WIDGETS_STATE.FILLED)
        : (this.column.widgetState = WIDGETS_STATE.EXPANDED);
    },
  },
};
</script>
